"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBalanceLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _definitions = require("@ppay/definitions");
var _ticker = require("../../ticker");
var _ui = require("../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getBalanceLabel = function getBalanceLabel(_ref, t) {
  var value = _ref.value,
    percent = _ref.percent,
    ticker = _ref.ticker;
  return (0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ticker !== null && ticker !== void 0 ? ticker : t('others'), ": ", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: value,
    ticker: ticker !== null && ticker !== void 0 ? ticker : _definitions.Ticker.USD
  }), !ticker ? '$' : '', " (", /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    value: percent,
    decimals: 2
  }), "%)"));
};
exports.getBalanceLabel = getBalanceLabel;